import { render, staticRenderFns } from "./CollectionTestSentBack.vue?vue&type=template&id=a89044de&"
import script from "./CollectionTestSentBack.vue?vue&type=script&lang=js&"
export * from "./CollectionTestSentBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports